import { WorkflowActivityCode } from 'interfaces/workflowActivities/workflowActivity'
import { ICanvasStep } from '../../../interfaces'

export const getIsApprovalTileWithoutATransition = (steps: ICanvasStep[]) => {
  return steps
    .filter(step => step.activityCode === WorkflowActivityCode.APPROVAL)
    .map(step => !!step?.activity?.transition)
    .includes(false)
}
